$(".custom-slideshow").slick({
  dots: true,
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
});

$(".custom__ingredients-section-content_slider").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  prevArrow: ".custom__ingredients-prev__button__ctm",
  nextArrow: ".custom__ingredients-next__button__ctm",
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".custom__header__submenu__content__row").slick({
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  nextArrow: ".header__submenu__slider__next",
  prevArrow: ".header__submenu__slider__prev",
});

$(".custom-logo--with-text-row_slider").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  nextArrow: ".logo_next__button__ctm",
  prevArrow: ".logo_prev__button__ctm",
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        slidesToShow: 3,
        dots: true,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        dots: true,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        dots: true,
      },
    },
  ],
});

$(".ctm__toggle_content").click(function () {
  if ($(".new-slideshow-container-column").hasClass("column_hidden_custom")) {
    // $(".new-slideshow-container-column").toggleClass("column_hidden_custom");
    $(".column_hidden_custom").slideToggle();
    $(".ctm__toggle_content").toggleClass("show");
    if ($(".ctm__toggle_content").hasClass("show")) {
      $(".ctm__toggle_content").html("hide");
    } else {
      $(".ctm__toggle_content").html("see all");
    }
  }

  // else {
  //   $(".ctm__toggle_content").html("see all");
  //    };
});
// Product Gallery Slick Slider
$(document).ready(function() {
  var $mainSlider = $('.product-gallery__main-slider');
  var $thumbSlider = $('.product-gallery__thumb-slider');

  if ($mainSlider.length) {
    if ($thumbSlider.length) {
      $mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        asNavFor: '.product-gallery__thumb-slider'
      });
      $thumbSlider.slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: false,
  asNavFor: '.product-gallery__main-slider',
  dots: false,
  arrows: false,
  focusOnSelect: true,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 6 } }
        ]
      });
    } else {
      $mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      });
    }
  }
});
// Fix duplicate badges on product page
$(document).ready(function() {
  var seen = {};
  $('.product-info on-sale-badge').each(function() {
    var text = $(this).text().trim();
    if (seen[text]) {
      $(this).remove();
    } else {
      seen[text] = true;
    }
  });
});
// Fix Horizon quantity selector and buy buttons styling
function fixHorizonStyles() {
  // Fix quantity selector border
  var wrappers = document.querySelectorAll('.quantity-selector-wrapper');
  wrappers.forEach(function(wrapper) {
    wrapper.style.cssText = 'display:inline-flex!important;align-items:center!important;border:1.5px solid #cccccc!important;border-radius:6px!important;overflow:hidden!important;height:52px!important;width:fit-content!important;';
  });

  // Fix quantity component internals
  var components = document.querySelectorAll('quantity-selector-component');
  components.forEach(function(comp) {
    comp.style.cssText = 'display:inline-flex!important;align-items:center!important;height:52px!important;';
    var minusBtn = comp.querySelector('.quantity-minus');
    var plusBtn = comp.querySelector('.quantity-plus');
    var input = comp.querySelector('input[type="number"]');
    if (minusBtn) minusBtn.style.cssText = 'width:44px!important;height:52px!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#f5f5f5!important;border:none!important;cursor:pointer!important;flex-shrink:0!important;';
    if (plusBtn) plusBtn.style.cssText = 'width:44px!important;height:52px!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#f5f5f5!important;border:none!important;cursor:pointer!important;flex-shrink:0!important;';
    if (input) input.style.cssText = 'width:44px!important;height:52px!important;text-align:center!important;border:none!important;border-left:1.5px solid #cccccc!important;border-right:1.5px solid #cccccc!important;background:#fff!important;font-size:16px!important;padding:0!important;';
  });

  // Fix Add to Cart button
  var atcBtns = document.querySelectorAll('.add-to-cart-button, .add-to-cart-component button[type="submit"]');
  atcBtns.forEach(function(btn) {
    btn.style.cssText = 'background:#1e316a!important;color:#fff!important;min-height:52px!important;border-radius:6px!important;font-size:16px!important;font-weight:600!important;border:none!important;cursor:pointer!important;width:100%!important;display:flex!important;justify-content:center!important;align-items:center!important;';
  });

  // Fix Buy it now button
  var buyNowBtns = document.querySelectorAll('.accelerated-checkout-block button');
  buyNowBtns.forEach(function(btn) {
    btn.style.cssText = 'background:#e53935!important;color:#fff!important;min-height:52px!important;border-radius:6px!important;font-size:16px!important;font-weight:600!important;border:none!important;cursor:pointer!important;width:100%!important;display:flex!important;justify-content:center!important;align-items:center!important;';
  });
}

// Run on page load and after any dynamic updates
$(document).ready(function() {
  fixHorizonStyles();
  // Run again after short delay for slow-loading components
  setTimeout(fixHorizonStyles, 500);
  setTimeout(fixHorizonStyles, 1500);
});
// Fix quantity selector +/- buttons (theme.js not loaded)
$(document).on('click', '.quantity-selector__button', function() {
  var $btn = $(this);
  var $input = $btn.siblings('.quantity-selector__input');
  var val = parseInt($input.val()) || 1;
  var label = $btn.attr('aria-label') || '';
  var min = parseInt($input.attr('min')) || 1;
  var max = parseInt($input.attr('max')) || 9999;

  if (label.toLowerCase().includes('decrease')) {
    if (val > min) $input.val(val - 1).trigger('change input');
  } else {
    if (val < max) $input.val(val + 1).trigger('change input');
  }
});